import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

export const addCompanyApi = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunction(data,apiConstants.COMPANIES.USER_ADD_COMPANY)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
